import type { IRoleRepository } from '@src/domain/rbac/repository/role_repository';

/**
 * Remove Roles from User Use Case
 * Removes multiple roles from a user
 */
export class RemoveRolesFromUserUseCase {
    constructor(private readonly roleRepository: IRoleRepository) { }

    async execute(userId: string, roleIds: string[]): Promise<void> {
        await this.roleRepository.removeRolesFromUser(userId, roleIds);
    }
}